import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}api/tigerpoly/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const tigerpolyApi = {
  getMembers: ({ params }) => instance().get('/member', { params }),
  getMember: ({ params }) => instance().get('/member/info', { params }),
  putMember: ({ data }) => instance().put('/member', data),
  getEmployeeIds: ({ params }) => instance().get('/member/employeeid-list', { params }),
  getPositions: ({ params }) => instance().get('/position', { params }),
  postPosition: ({ data }) => instance().post('/position', data),
  putPosition: ({ data }) => instance().put('/position', data),
  deletePosition: ({ data }) => instance().delete('/position', { data }),
  getDepartments: ({ params }) => instance().get('/department', { params }),
  postDepartment: ({ data }) => instance().post('/department', data),
  putDepartment: ({ data }) => instance().put('/department', data),
  deleteDepartment: ({ data }) => instance().delete('/department', { data }),
  getRankingReport: ({ params }) => instance().get('/report/ranking', { params }),
  getReport: ({ params }) => instance().get('/report', { params }),
  putReportStatus: ({ data }) => instance().put('/report/status', data)
}
export default tigerpolyApi



// WEBPACK FOOTER //
// ./src/api/tigerpoly.js